import React, { useEffect, useState } from "react";
import TextInput from "../../common/textfield/TextInput";
import { Col, Row, Table } from "react-bootstrap";
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import { patientListTitle, patientSelectionFormikObject } from "./Constant";
import { Skeleton, TableCell, Tooltip } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { Button } from "../../common/Button";
import { useFormik } from "formik";
import { failed } from "../../common/Toastify";
import { searchPatient } from "../../apps/api/Patient";
import CustomPagination from "../../common/components/Pagination/CustomPagination";
import moment from "moment";
import * as momentTimezone from "moment-timezone";
import { ViewDate } from "../../../utils/DateSupport";
import { useSelector } from "react-redux";
import { getHCNAuthorityList } from "../../api/HCN";
import SelectFiled from "../../common/textfield/SelectFiled";
import { getOrganizationSettings } from "../../api/Organization";

const PatientSelection = ({ orgId, formikInBoundCall, handleAddPatient, dashboard = false, patient, resetPatient, onSearchLoadingChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [isRegion, setIsRegion] = useState(false);
  const [addPatientButEnable, setAddPatientButEnable] = useState(false);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]); 
  const permissions = useSelector((state) => state?.auth?.user?.permissions); 
  const hasAccess = (permissions?.includes('patient-create') || userRoles?.includes("Super-Admin"));
  const getValueQuestionnair = (tagValue) => formikInBoundCall?.values?.questionResponse?.find(item => item.tag === tagValue)?.answer?.[0]?.answer
  const getValueQuestionnairRadio = (tagValue) => formikInBoundCall?.values?.questionResponse.find((obj)=> obj?.tag === tagValue)?.answer?.find((val)=>val?.answer === true)?.option
  const [hasSearched, setHasSearched] = useState(false);
  const [hcnAuthorityList, setHcnAuthorityList] = useState([])
  const [ecrEnabled, setEcrEnabled] = useState(false)

  const formik = useFormik({
    initialValues: {
      org_id:"",
      firstName: getValueQuestionnairRadio("SELFCALLING") === "Yes" ?  localStorage.getItem("firstName")  : "",
      lastName: getValueQuestionnairRadio("SELFCALLING") === "Yes" ? localStorage.getItem("lastName") : "",
      birthDate: "",
      healthCardNumber: "",
      hcnAuthority: ""
    },
    ...patientSelectionFormikObject,
    onSubmit: (values) => {  
      setBtnLoading(true);
      setIsLoading(true);
      onSearchLoadingChange?.(true);
      const convertDateFormat = (originalDate) => {
        const dateObject = new Date(originalDate);
        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0');
        const year = dateObject.getFullYear();
        const formattedDate = `${month}-${day}-${year}`;
        return formattedDate;
      };
      const timeZoneGuess = moment.tz.guess();
      const timeZoneParts = timeZoneGuess.split('/');
      let region = timeZoneParts[0];     
      let dateData = "";
      if(values.birthDate == "" || values.birthDate == NaN-NaN-NaN  || values.birthDate == "NaN-NaN-NaN" || !values.birthDate ){
        dateData = "";
      }else{  
        if( ( region == "America" || region == "Canada" ) && isRegion == true  ){
          let dateDataNew = convertDateFormat(values.birthDate );;
          let currentDate = new Date(dateDataNew);
          currentDate.setDate(currentDate.getDate() + 1);
           dateData = convertDateFormat(currentDate);  
           setIsRegion(false);
        }else{
          dateData = convertDateFormat(values.birthDate );;
        }        
      } 
      values.birthDate = dateData;  
      searchPatient({ ...values, org_id: orgId })
        .then((res) => {
          if (res.status === true) {
            // Check for errors in the response
            if (res.errors && Array.isArray(res.errors) && res.errors.length > 0) {
              res.errors.forEach((error) => {
                const errorMessage = error.source && error.message 
                  ? `${error.source === "ecr" ? "Client Registry" : error.source}: ${error.message}` 
                  : error.message || error.error || "An error occurred";
                failed(errorMessage);
              });
            }
            setFilterData(res?.result || []);
            setAddPatientButEnable(true)
            setBtnLoading(false);
            setIsLoading(false);
            setHasSearched(true);
          } else {
            setFilterData([]);
            setBtnLoading(false);
            setIsLoading(false);
            failed(res.error || res.message || "Search failed");
          }
        })
        .catch((res) => {
          setFilterData([]);
          setIsLoading(false);
          setBtnLoading(false);
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res.message
          );
        })
        .finally(() => {
          setBtnLoading(false);
          setIsLoading(false);
          onSearchLoadingChange?.(false);
        });
    },
  });

  const handleAddPatientClick = () => {  
    formikInBoundCall.setFieldValue('hcn',  formik.values?.healthCardNumber || '');  
    formikInBoundCall.setFieldValue('date_of_birth', formik.values?.birthDate || '');
    formikInBoundCall.setFieldValue('first_name', formik.values?.firstName || '');
    formikInBoundCall.setFieldValue('last_name', formik.values?.lastName || '');
    handleAddPatient();
  };

  const handleDateChange = (val) => { 
  
    if(val == null || val === "") { 
        formik.setFieldValue("birthDate", ""); 
    } 
    const momentDate = moment(val, 'MMM-DD-YYYY', true);
    const isValidDate = momentDate.isValid(); 
    
    if(isValidDate){
        formik.setFieldValue("birthDate", moment(val).format("MM-DD-YYYY")?.replace(/-/g,'/')); 
    } else{
        formik.setFieldValue("birthDate", val);
        formik.setFieldError("birthDate", 'Invalid date format'); 
    } 
  };

  const handleClearDate = () => {
    formik.setFieldValue("birthDate", "");
    formik.setFieldError("birthDate", undefined);
    handleDateChange(null);
  };

  const handlePatientClick = (data) => {
    const baseUrl = window.location.origin;
    const patientId = data?.id;
    const patientName = data?.name?.[0]?.text;
    const url = `${baseUrl}/app/patients-details?patientId=${patientId}`//&patientName=${patientName}`;
    window.open(url, "_blank");
  };

  const handleSearchPatient = ()=>{
    resetPatient(null);
    formik.handleSubmit();
    setHasSearched(true);
  }

  useEffect(() => {
    if (hasSearched) {
      setAddPatientButEnable(false);
    }
  }, [
    formik.values.firstName,
    formik.values.lastName,
    formik.values.birthDate,
    formik.values.healthCardNumber
  ]);


 let formattedDate;
 let hcnValue
  useEffect(() => {
    formik.resetForm()
    if (patient) {
      if (typeof patient?.birthDate === "string") {
        const dateParts = patient.birthDate.split("-");
        if (dateParts.length === 3) {
          formattedDate = `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`;
        }
      }
      const hcnIdentifier = patient?.identifier?.find(identifier => identifier?.type === "HCN");
      hcnValue = hcnIdentifier ? hcnIdentifier?.value : '-';
      formikInBoundCall.setFieldValue("patientId", patient?.id); 
      formikInBoundCall.setFieldValue("patientName", patient?.name?.[0]?.text)
    }
  }, [patient])

  useEffect(() => {
   getHCNAuthorityList(orgId).then((res) => {
     if (res?.status === true) {
       const sortedAuthorities = (res.data || [])
         .slice()
         .sort((a, b) => (a?.display || "").localeCompare(b?.display || ""));

       const allAuthorities = sortedAuthorities.map((item) => ({
           ...item,
           value: item?.authority,
           name: item?.display
         }));

       setHcnAuthorityList(allAuthorities || []);

       const defaultAuthority = sortedAuthorities?.find((item) => item?.isDefault);
       const singleAuthority = allAuthorities?.length === 1 ? allAuthorities[0] : null;

       // When ECR is enabled, auto-select:
       // - the only authority if there is exactly one option, or
       // - the default authority when multiple options exist.
       if (!formik.values.hcnAuthority && ecrEnabled === true) {
         const authorityToSelect = singleAuthority || defaultAuthority;
         if (authorityToSelect?.authority) {
           formik.setFieldValue("hcnAuthority", authorityToSelect.authority);
         }
       }
     }
   })

 }, [orgId, ecrEnabled])

  useEffect(() => {
    getOrganizationSettings(orgId).then((res) => {
      if (res?.status === true) {
        setEcrEnabled(res?.data?.ecrEnabled)
      }
    })
  }, [orgId])

  const handleAuthorityChange = (e) => {
    formik.setFieldValue("hcnAuthority", e.target.value)
  };

  const handlePatientSelect= (event, data) => {
    formikInBoundCall.setFieldValue("patientId", event.target.value);
    formikInBoundCall.setFieldValue("patientName", data?.name?.[0]?.text);
    formikInBoundCall.setFieldValue("selectedPatientData", data);
  };

  const renderSourceTags = (source) => {
    if (!source) return null;
    const sources = Array.isArray(source) ? source : [source];
    const extSources = sources.filter((src) => src === "EXT");
    
    if (extSources.length === 0) return null;
    
    return (
      <>
        {extSources.map((src, index) => (
          <Tooltip key={index} title="Patient retrieved from external source" arrow>
            <span 
              style={{
                display: "inline-block", 
                marginLeft: "8px", 
                padding: "2px 6px", 
                backgroundColor: "#e0e0e0", 
                color: "#666", 
                fontSize: "11px", 
                borderRadius: "3px", 
                fontWeight: "500"
              }}
            >
              {src}
            </span>
          </Tooltip>
        ))}
      </>
    );
  };

  return (
    <>
        <Row>
          <Col sm={dashboard && 2}>
            <TextInput
              keyField={"firstName"}
              label={"First Name"}
              formik={formik}
              placeholder={"First Name"}
              hideRequired={true}
            />
          </Col>
          <Col sm={dashboard && 2}>
            <TextInput
              keyField={"lastName"}
              label={"Last Name"}
              formik={formik}
              placeholder={"Last Name"}
              hideRequired={true}
            />
          </Col>
          <Col sm={dashboard && 2}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div style={{ flex: 1 }}>
                <DateSelectorWithoutFormik
                  formik={formik}
                  keyField={'birthDate'}
                  label="DOB"
                  value={formik.values.birthDate ? moment(formik.values.birthDate).format("YYYY-MM-DD") : null}
                  handleChange={handleDateChange}
                  isError={
                    formik?.touched?.end && formik?.errors?.end
                      ? formik?.errors?.end
                      : ""
                  }
                  maxDate={moment()}
                  hideRequired={true}
                />
              </div>
              {formik.values.birthDate && (
                <Tooltip title="Clear">
                  <ClearIcon 
                    style={{ 
                      color: "#666", 
                      cursor: "pointer", 
                      fontSize: "20px",
                      alignSelf: "center"
                    }} 
                    onClick={handleClearDate}
                  />
                </Tooltip>
              )}
            </div>
          </Col>
          <Col sm={dashboard && 2}>
            <TextInput
              keyField={"healthCardNumber"}
              label={"Patient Identifier"}
              formik={formik}
              placeholder={"Patient Identifier"}
              hideRequired={true}
            />
          </Col>
          {ecrEnabled && hcnAuthorityList?.length > 1 && (
            <Col sm={dashboard && 2}>
              <SelectFiled
                formik={formik}
                options={hcnAuthorityList}
                fieldtype={"TextInput"}
                keyField={"hcnAuthority"}
                label={"Identifier Type"}
                placeholder={"Identifier Type"}
                required={true}
                onChange={handleAuthorityChange}
                selectDisabledValue={true}
              />
            </Col>
          )}
        </Row>
        {formik?.errors["allSearchFieldsEmpty"] ? (<div style={{fontSize : "14px", color: "#dc3545", paddingTop: "5px", marginTop: "-20px", marginBottom: "20px"}}>{formik?.errors["allSearchFieldsEmpty"]} </div>) : null}
        <div style={{display: "flex", justifyContent: "center"}}>
          <div style={{marginRight: "25px"}}>
            <Col>
              <Button
                type="button"
                isLoading={btnLoading}
                onClick={handleSearchPatient}
                style={{fontSize : "14px", padding : "8px 10px"}}
              >
                Search Patient
              </Button>
            </Col>
            </div>
            <div>
            {!dashboard && addPatientButEnable && hasAccess && <Col>
              <Button variant="secondary" onClick={handleAddPatientClick} style={{fontSize : "14px", padding : "8px 10px"}}>
                + Add New Patient
              </Button>
            </Col>}
            </div>
        </div>
      <div className="table-wrap">
        <Table responsive>
          <thead>
            <tr>
              <th></th>
              {patientListTitle?.map((title) => (
                <th>{title}</th>
              ))}
            </tr>
          </thead>
          {patient ? <tbody>
            <tr>
              <td>
                {!dashboard && <input  style={{cursor: "pointer"}} type='radio' name={`radio`} value={patient?.id} checked={true} onChange={(e)=> {formikInBoundCall.setFieldValue("patientId", e.target.value); formikInBoundCall.setFieldValue("patientName", patient?.name?.[0]?.text)}}/>}
              </td>
              <td><span style={{cursor: "pointer"}} onClick={() => handlePatientClick(patient)}>{patient?.name?.[0]?.text?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>{renderSourceTags(patient?.source)}</td>
              <td>{patient?.gender}</td>
              <td>{ViewDate(patient?.birthDate)}</td>
              <td>{patient?.identifier?.find(identifier => identifier?.type === "HCN")?.value || patient?.identifier?.find(identifier => identifier?.source === "EXT")?.value || '-'}</td> 
              <td>{patient?.address?.[0]?.line?.[0]}</td>
              <td>{patient?.address?.[0]?.city}</td>
              <td>{patient?.address?.[0]?.state || patient?.address?.[0]?.province}</td>
            </tr>
          </tbody> : 
          <tbody>
            {isLoading ? (
              [1, 2, 3, 4, 5, 6, 7, 8]?.map((val) => (
                <tr key={val}>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                  <td>
                    <Skeleton animation="wave" />
                  </td>
                </tr>
              ))
            ) : filterData?.length > 0 ? (
              filterData
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((data, index) => { 
                  var formattedDateString = data?.birthDate ?  ViewDate(data?.birthDate) : "-";
                  // const hcnIdentifier = data?.identifier?.find(identifier => identifier?.type === "HCN");
                  // const hcnValue = hcnIdentifier ? hcnIdentifier?.value : '-'; 
                  const hcnIdentifier = data?.identifier?.find(identifier => identifier?.type === "HCN") || {};
                  const hcnValue = hcnIdentifier && hcnIdentifier?.value  ? hcnIdentifier?.value : '-'; 
                  const hcnExternal = data?.identifier?.find((item) => item?.source === "EXT")?.value
                  return (
                    <>
                      <tr key={index}>
                        <td>
                          {!dashboard && <input style={{cursor: "pointer"}} type='radio' name={`radio`} value={data?.id} onChange={(e)=> handlePatientSelect(e, data)}/>}
                        </td>
                        <td><span style={{cursor: "pointer"}} onClick={() => handlePatientClick(data)}>{data?.name?.[0]?.text?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>{renderSourceTags(data?.source)}</td>
                        <td style={{textTransform: "capitalize"}}>{data?.gender}</td>
                        <td>{formattedDateString}</td>
                        <td>{hcnExternal || hcnValue}</td>
                        <td>{data?.address?.[0]?.line?.[0]}</td>
                        <td style={{textTransform: "capitalize"}}>{data?.address?.[0]?.city}</td>
                        <td>{data?.address?.[0]?.state || data?.address?.[0]?.province}</td>
                      </tr>
                    </>
                  );
                })
            ) : (
              <tr>
                <TableCell colSpan="8" style={{ textAlign: "center" }}>
                  No Records Found
                </TableCell>
              </tr>
            )}
          </tbody>}
        </Table>
        {filterData?.length > 0 ? (
          <div>
            <CustomPagination
              tableData={filterData}
              totalRows={filterData?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              handlePage={(pageNo) => setPage(pageNo)}
            />
          </div>
        ) : null}
      </div>
      <div>
        {formikInBoundCall?.touched["patientId"] && formikInBoundCall?.errors["patientId"] ? (
          <div className="error-text">
            {formikInBoundCall?.errors["patientId"]}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default PatientSelection;
